window.addEventListener("DOMContentLoaded", () => {
  switch (WindCreekData.propertyName) {
    case 'Atmore':
      (function(n,u){
        let e;
        window.CXoneDfo=n,
          window[n]=window[n]||function(){(window[n].q=window[n].q||[]).push(arguments);},window[n].u=u,
          e=document.createElement("script"),e.type="module",e.src=u+"?"+Math.round(Date.now()/1e3/3600),
          document.head.appendChild(e);
      })('cxone','https://web-modules-de-na1.niceincontact.com/loader/1/loader.js');
      cxone('init', '3752');
      cxone('guide', 'init', '5f11fe98-424f-4fd4-9bfb-9422076f3939');
      break;
    case 'Bethlehem':
      (function(n,u){
        let e;
        window.CXoneDfo=n,
          window[n]=window[n]||function(){(window[n].q=window[n].q||[]).push(arguments);},window[n].u=u,
          e=document.createElement("script"),e.type="module",e.src=u+"?"+Math.round(Date.now()/1e3/3600),
          document.head.appendChild(e);
      })('cxone','https://web-modules-de-na1.niceincontact.com/loader/1/loader.js');
      cxone('init', '3752');
      cxone('guide', 'init', '68e4c2a8-467c-439c-a517-cbcec7fd4a90');
      break;
    case 'Chicago Southland':
      if (WindCreekData.pagePath !== 'page-chicagosouthland-open-fall-2024') {
        (function(n,u){
          let e;
          window.CXoneDfo=n,
            window[n]=window[n]||function(){(window[n].q=window[n].q||[]).push(arguments);},window[n].u=u,
            e=document.createElement("script"),e.type="module",e.src=u+"?"+Math.round(Date.now()/1e3/3600),
            document.head.appendChild(e);
        })('cxone','https://web-modules-de-na1.niceincontact.com/loader/1/loader.js');
        cxone('init', '3752');
        cxone('guide', 'init', '01367d0a-2873-41bf-a4d6-39c198d67325');
      }
      break;
    case 'Miami':
      (function(n,u){
        let e;
        window.CXoneDfo=n,
          window[n]=window[n]||function(){(window[n].q=window[n].q||[]).push(arguments);},window[n].u=u,
          e=document.createElement("script"),e.type="module",e.src=u+"?"+Math.round(Date.now()/1e3/3600),
          document.head.appendChild(e);
      })('cxone','https://web-modules-de-na1.niceincontact.com/loader/1/loader.js');
      cxone('init', '3752');
      cxone('guide', 'init', '2fcbb9c6-ecdf-454a-bca9-cbbc21fbf3ac');
      break;
    case 'Montgomery':
      (function(n,u){
        let e;
        window.CXoneDfo=n,
          window[n]=window[n]||function(){(window[n].q=window[n].q||[]).push(arguments);},window[n].u=u,
          e=document.createElement("script"),e.type="module",e.src=u+"?"+Math.round(Date.now()/1e3/3600),
          document.head.appendChild(e);
      })('cxone','https://web-modules-de-na1.niceincontact.com/loader/1/loader.js');
      cxone('init', '3752');
      cxone('guide', 'init', '8528f7b1-d48d-47c9-b744-cd214175949b');
      break;
    case 'WaSheShu':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'c0b8edaa-32c2-475c-b6fa-964f6a6166e0',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
    case 'Wetumpka':
      (function(n,u){
        let e;
        window.CXoneDfo=n,
          window[n]=window[n]||function(){(window[n].q=window[n].q||[]).push(arguments);},window[n].u=u,
          e=document.createElement("script"),e.type="module",e.src=u+"?"+Math.round(Date.now()/1e3/3600),
          document.head.appendChild(e);
      })('cxone','https://web-modules-de-na1.niceincontact.com/loader/1/loader.js');
      cxone('init', '3752');
      cxone('guide', 'init', '74d4b9fb-8211-4e12-b28c-28f671ca9d14');
      break;
    case 'Aruba':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'32f26fb4-147b-4f72-ba7d-7e9c94c29e36',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
    case 'Curacao':
      icPatronChat.init({serverHost:'https://home-c29.incontact.com',bus_no:4597703,poc:'a7b5cb8b-6cd4-4681-9c87-406a49bf64be',params:['FirstName','Last Name','first.last@company.com',555-555-5555]});
      break;
  }
});
